
<template>
  <el-container class="courseIndex">
    <el-header>
      <div class="head-top">
        <img
          class="logo"
          src="../assets/logo1.png"  @click="goout">
      </div>
    </el-header>
      <el-main>
        <img src="../assets/bg-top-02.png" class="bg-top" alt="">
        <h3>Courses Schedule</h3>
        <div class="searchBox flex_justify_center">
          <div>
            <p>Subject</p>
            <el-select v-model="valueSubject" @change="search"  clearable placeholder="Select a Subject">
             <el-option v-for="item in SubOptions"
                :key="item.id"
                :label="item.title"
                :value="item.id">{{item.title}}
              </el-option>
            </el-select>
          </div>
          <div>
            <p>Level</p>
            <el-select v-model="valueLevel" clearable placeholder="Please Select">
              <el-option
                v-for="item in levelOptions"
                :key="item.id"
                :label="item.title"
                :value="item.id">{{item.title}}
              </el-option>
            </el-select>
          </div>
          <div>
            <p>Day in week</p>
            <el-select v-model="valueWeek" multiple clearable placeholder="Please Select" style="width:310px;">
              <el-option
                v-for="item in weekOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">{{item.name}}
              </el-option>
            </el-select>
          </div>
          <div>
            <p>Frequency</p>
            <el-select v-model="valueFrequency" clearable placeholder="Please Select">
              <el-option
                v-for="item in frequencyOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">{{item.name}}
              </el-option>
            </el-select>
          </div>
          <el-button @click="handleCurrentChange(1)">Apply</el-button>

        </div>
      </el-main>
      <div class="mainContent">
        <div class="courseList">
          <p class="result">Search results <span>"{{seach}}"</span></p>
          <div class="listInfo">
            <div class="courseTitle" v-for="(item, i) in courseData" :key="i">
              <p>Class Type: {{item.class_type?item.class_type:'-'}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Course ID: {{item.course_id}} ({{item.level_title}})</p>
              <div class="perCourse">
                <div>
                  <p v-for="(d, j) in item.date_time" :key="j">{{d.split('-')[0]}} - <b>{{d.split('-')[1]}}</b></p>
                </div>
                <div class="flex_center">
                    <p v-for="(w, k) in weekOptions" :key="k">
                      <img :src="item.weekday.indexOf(w.id)>-1?w.img_act:w.img" alt="">
                    </p>
                </div>
                <div>
                  <p v-if="item.level_group_title"><i>Level: </i>{{item.level_group_title}}</p>
                </div>
              </div>
            </div>
          </div>
          <el-pagination
              v-if="total>0"
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-size="pageSize"
              layout="prev, pager, next"
              :total="total">
            </el-pagination>
          <p>Can’t find a lesson that fits your schedule?</p>
          <p>Contact us and we will arrange for you!</p>
        </div>
      </div>
      <el-footer>
        Classover.com © 2026
      </el-footer>
  </el-container>
</template>
<script>
import IndexHeader from './views/header'
export default {
  components: {
    IndexHeader
  },
  data () {
    return {
      courseData: [],
      SubOptions: [],
      levelOptions: [],
      weekOptions:[
        {
          title:'M',
          name:'Mon',
          id:1,
          img:require('../assets/m.svg'),
          img_act:require('../assets/m_active.svg'),
        },
        {
          title:'T',
          name:'Tue',
          id:2,
          img:require('../assets/t.svg'),
          img_act:require('../assets/t_active.svg'),
        },
        {
          title:'W',
          name:'Wed',
          id:3,
          img:require('../assets/w.svg'),
          img_act:require('../assets/w_active.svg'),
        },
        {
          title:'Th',
          name:'Thur',
          id:4,
          img:require('../assets/th.svg'),
          img_act:require('../assets/th_active.svg'),
        },
        {
          title:'F',
          name:'Fri',
          id:5,
          img:require('../assets/f.svg'),
          img_act:require('../assets/f_active.svg'),
        },
        {
          title:'Sa',
          name:'Sat',
          id:6,
          img:require('../assets/sa.svg'),
          img_act:require('../assets/sa_active.svg'),
        },
        {
          title:'Su',
          name:'Sun',
          id:0,
          img:require('../assets/su.svg'),
          img_act:require('../assets/su_active.svg'),
        }
      ],
      frequencyOptions:[
        {
          id:'',
          name:'All',
        },
        {
          id:'1',
          name:'1 lesson per week',
        },
        {
          id:'2',
          name:'2 lessons per week',
        },
        {
          id:'3',
          name:'3 lessons per week',
        }
      ],
      valueSubject:'',
      valueLevel:'',
      valueWeek:[1,2,3,4,5,6,0],
      valueFrequency:'',
      pageSize:10,
      pageNum:1,
      total:1,
      seach:''
    }
  },
  created () {
    this.getSubjects()
  },
  methods:{
    goout(){
      window.location.href='https://classover.com'
    },
    getSubjects () {
      this.$http.get('/api/getSubject').then((res) => {
        if (res.data.code == 200) {
          console.log(res)
          this.SubOptions = res.data.data

          this.valueSubject = this.SubOptions[0].id
          // this.search(this.SubOptions[0].id)
          this.getlevelsData(1)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    search (id) {
      if(id){
        this.SubOptions.map((item, i) => {
          if (item.id == id) {
            this.subInfo = item
            this.getlevelsData()
          }
        })
      }else{
        this.valueLevel = ''
        this.levelOptions = []
      }
    },
    getlevelsData (num) {
      this.$http.get('/api/getSubjectLevelsGroup?subject_id='+(num==1?this.valueSubject:this.subInfo.id)).then((res) => {
        if (res.data.code == 200) {
          this.levelOptions = res.data.data
          this.valueLevel = this.levelOptions[0].id
          if(num==1){
            this.getCourseData()
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    getCourseData () {
      this.$http.post('/api/getCoursesSchedule',{
        time_diff:this.utils.timeZone(),
        pagesize:this.pageSize,
        page:this.pageNum,
        subject_id:this.valueSubject,
        level_group_id:this.valueLevel,
        weekday:this.valueWeek,
        frequency:this.valueFrequency
      }).then((res) => {
        if (res.data.code == 200) {
          this.courseData = res.data.data.datas
          this.total = res.data.data.total
          this.seach = res.data.data.seach
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    handleCurrentChange (val) {
      this.pageNum = val
      this.getCourseData()
    }
  }
}
</script>
<style lang="less" scoped>
  #app{
    height: 100%;
  }
  .courseIndex{
    width: 100%;
    min-height: 100vh;
    margin: 0 auto;
    background: #fff;
    .el-header{
        width: 100%;
        height:80px!important;
        padding:0;
        box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
        .head-top{
          width:1200px;
          height:100%;
          margin:0 auto;
          display: flex;
          align-items: center;
        }
        .logo {
          height: 50px;
          cursor:pointer;
          img{
            width:100%;
            height:100%;
          }
        }
    }
    .el-main{
      padding:0;
      width:100%;
      height:368px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content:center;
      background: url('../assets/Rectangle.png') center center no-repeat;
      background-size:100% 100%;
      position: relative;
      .bg-top{
        position: absolute;
        left:30px;
        top:63px;
        width:313px;
        height:241px;
      }
      h3{
        font-size:30px;
        color:#3B495E;
        font-weight: 500;
        text-align: center;
      }
      .searchBox{
        width:1200px;
        height:80px;
        margin-top:43px;
        background: #FFFFFF;
        border-radius: 5px;
        z-index:111;
        >div{
          flex:1;
          padding:0 20px;
          margin:17px 0 14px;
          border-right: 1px solid #E0E0E0;
          &:nth-child(4n){
            border:none;
          }
          p{
            color: #88909C;
            font-size:14px;
          }
          .el-select{
            width:100%;
            /deep/ .el-tag.el-tag--info{
              border: none;
              font-size: 16px;
              color: #3B495E;
              background: none;
              margin:0;
              padding-left:0;
              .el-tag__close{
                display: none;
              }
              &:after
              {
              content:",";
              }
              &:last-child::after{
                content: ''
              }
            }
            /deep/ .el-input__inner{
              border:none;
              font-size: 16px;
              color: #3B495E;
              padding:0;
            }
          }
        }
        >.el-button{
          width: 122px;
          height: 80px;
          background: #FA7B5E;
          border-radius: 0px 5px 5px 0px;
          font-size: 18px;
          color:#fff;
        }
      }
    }
    .mainContent{
      width:100%;
      .courseList{
        width:1200px;
        margin:0 auto;
        >p:not(.result){
          font-size: 16px;
          line-height :25.47px;
          color: #FD6540;
          text-align: center;
        }
        .result{
          margin:45px 0 33px;
          font-size: 16px;
          color: #3B495E;
          span{
            color: #FD6540;
          }
        }
        .listInfo{
          margin-bottom:20px;
          .courseTitle{
            margin-bottom:15px;
            >p{
              font-size: 12px;
              color: #BDBDBD;
              text-align: right;
              margin-bottom: 5px;
            }
            .perCourse{
              padding: 30px 0;
              background: #FFFFFF;
              border: 1px solid #E0E0E0;
              border-radius: 12px;
              display: flex;
              align-items: center;
              >div{
                flex:1;
                text-align: center;
                p{
                  line-height: 24px;
                  i{
                    font-style: normal;
                    color: #BDBDBD;
                    font-size: 12px;
                  }
                  b{
                    color:#FD6540;
                  }
                }
              }
              .flex_center{
                display: flex;
                align-items: center;
                p{
                  height:25px;
                  margin-right:10px;
                  img{
                    height: 100%;
                  }
                }
              }
            }
          }
        }
      }
    }
    .el-footer{
      text-align: center;
      line-height: 60px;
      margin-top:100px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/course.vue